import script from "./AlarmSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlarmSettings.vue?vue&type=script&setup=true&lang=ts"

import "./AlarmSettings.vue?vue&type=style&index=0&id=5ce465c5&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce465c5"]])

export default __exports__